let KlavHandle = [
  {
    "ID": 8000687112486,
    "Handle": "undersink-home-water-filters"
  },
  {
    "ID": 8000687341862,
    "Handle": "water_filters_replace_ten_inch"
  },
  {
    "ID": 8000687374630,
    "Handle": "water_filters_reverse_osmosis"
  },
  {
    "ID": 8000687702310,
    "Handle": "reverse-osmosis-cartridge-renewal"
  },
  {
    "ID": 8000687767846,
    "Handle": "undersink-water-filter-cartridge-renewal"
  },
  {
    "ID": 8000687833382,
    "Handle": "twin-water-filter-cartridges-renewal"
  },
  {
    "ID": 8000687898918,
    "Handle": "triple-system-water-filter-cartridges-renewal"
  },
  {
    "ID": 8000687964454,
    "Handle": "american_style_fridge_replacement_water_filter"
  },
  {
    "ID": 8000688029990,
    "Handle": "american-style-fridge-water-filter-cartridge-renewal"
  },
  {
    "ID": 8000688062758,
    "Handle": "water-dispenser-cold-only-asis-chsca2-plus-acik41-kit"
  },
  {
    "ID": 8000688095526,
    "Handle": "water-dispenser-hot-and-cold-asis-chsha2-plus-acik41-kit"
  },
  {
    "ID": 8000688128294,
    "Handle": "water-dispenser-replacement-cartridge"
  },
  {
    "ID": 8000688193830,
    "Handle": "the-black-box"
  },
  {
    "ID": 8000688259366,
    "Handle": "new-housing-unit-incl-cartridge"
  },
  {
    "ID": 8000688488742,
    "Handle": "water-filters-tap-only"
  },
  {
    "ID": 8000689471782,
    "Handle": "your-discount-in-line-water-filter-replacement"
  },
  {
    "ID": 8000689537318,
    "Handle": "water_filters_buy_cooler"
  },
  {
    "ID": 8000689602854,
    "Handle": "water-chiller-chuc3-with-undersink-water-filter-ukwf"
  },
  {
    "ID": 8000689668390,
    "Handle": "undersink-water-filter-cartridge-renewal-eds-mates"
  },
  {
    "ID": 8000689701158,
    "Handle": "your-discount-in-line-water-filter-renewal"
  },
  {
    "ID": 8000689766694,
    "Handle": "reverse-osmosis-filter-cartridge-renewal-kit"
  },
  {
    "ID": 8000689799462,
    "Handle": "undersink-drinking-water-filter"
  },
  {
    "ID": 8000689832230,
    "Handle": "undersink-water-filter-with-tap"
  },
  {
    "ID": 8000689864998,
    "Handle": "saddle-valve"
  },
  {
    "ID": 8000689897766,
    "Handle": "reverse-osmosis-memrane-only"
  },
  {
    "ID": 8000689930534,
    "Handle": "samsung_fridge_replacement_samsung_filter_outside"
  },
  {
    "ID": 8000689963302,
    "Handle": "water-filter-tubing-per-meter"
  },
  {
    "ID": 8000689996070,
    "Handle": "connection-adapter-set-for-9-6mm-to-6-4mm-ie-1-4-inch"
  },
  {
    "ID": 8000690094374,
    "Handle": "connection-adapter-set-for-10mm-to-1-4-inch"
  },
  {
    "ID": 8000690127142,
    "Handle": "undersink-water-filter-plus-leak-controller"
  },
  {
    "ID": 8000690159910,
    "Handle": "american-style-fridge-filter-plus-leak-controller"
  },
  {
    "ID": 8000690192678,
    "Handle": "reverse-osmosis-system-plus-leak-controller"
  },
  {
    "ID": 8000690225446,
    "Handle": "under_sink_economy_filters"
  },
  {
    "ID": 8000690258214,
    "Handle": "water-chiller-only-no-filter-with-installation-kit"
  },
  {
    "ID": 8000690356518,
    "Handle": "filter-changing-wrench"
  },
  {
    "ID": 8000690422054,
    "Handle": "lg_fridge_replacements_lg_external"
  },
  {
    "ID": 8000690454822,
    "Handle": "atag_fridge_replacements"
  },
  {
    "ID": 8000690487590,
    "Handle": "kuppersbusch_fridge_replacements"
  },
  {
    "ID": 8000690553126,
    "Handle": "bosch_siemens_fridge_replacements"
  },
  {
    "ID": 8000690618662,
    "Handle": "daewoo_fridge_filters"
  },
  {
    "ID": 8000690716966,
    "Handle": "ge_fridge_filters"
  },
  {
    "ID": 8000690782502,
    "Handle": "hotpoint-fridge-style-external-water-filter"
  },
  {
    "ID": 8000690848038,
    "Handle": "whole-house-water-filter"
  },
  {
    "ID": 8000690946342,
    "Handle": "garden_water_filters"
  },
  {
    "ID": 8000690979110,
    "Handle": "shower_water_filter_replace"
  },
  {
    "ID": 8000691011878,
    "Handle": "shower_water_filters"
  },
  {
    "ID": 8000691044646,
    "Handle": "brita_jug_filters"
  },
  {
    "ID": 8000691110182,
    "Handle": "samsung_fridge_internal_filters"
  },
  {
    "ID": 8000691175718,
    "Handle": "special-filter-for-caravans-and-boats"
  },
  {
    "ID": 8000691208486,
    "Handle": "caravan-and-boat-taste-and-odour-filter-kit"
  },
  {
    "ID": 8000691241254,
    "Handle": "caravan-and-boat-filter-cartridge"
  },
  {
    "ID": 8000691339558,
    "Handle": "neff_fridge_replacements"
  },
  {
    "ID": 8000691372326,
    "Handle": "american-style-fridge-filter-customer-loyalty-renewal"
  },
  {
    "ID": 8000691405094,
    "Handle": "wall-mounting-bracket-clips-x-2"
  },
  {
    "ID": 8000691437862,
    "Handle": "three-way-tap"
  },
  {
    "ID": 8000691831078,
    "Handle": "three-way-tap-white"
  },
  {
    "ID": 8000691896614,
    "Handle": "whole-house-40-l-minute"
  },
  {
    "ID": 8000691962150,
    "Handle": "domestic-water-filter-60-l-minute"
  },
  {
    "ID": 8000692027686,
    "Handle": "replacement-samsung-fridge-filter"
  },
  {
    "ID": 8000692093222,
    "Handle": "commercial-water-filter-40-l-min-incl-vat"
  },
  {
    "ID": 8000692158758,
    "Handle": "commercial-water-filter-20-l-min-incl-vat"
  },
  {
    "ID": 8000692289830,
    "Handle": "water_filters_icemakers"
  },
  {
    "ID": 8000692388134,
    "Handle": "this-new-product-should-be-hilited-on-new-income-report"
  },
  {
    "ID": 8000692453670,
    "Handle": "shower-water-filter-for-hair-and-beauty-salons"
  },
  {
    "ID": 8000692519206,
    "Handle": "total-salon-water-filter-solution-incl-vat"
  },
  {
    "ID": 8000692584742,
    "Handle": "whole-house-plus-0-5-micron-ceramic-filter-and-housing"
  },
  {
    "ID": 8000692715814,
    "Handle": "standard-whole-house-water-filter-20l-minute"
  },
  {
    "ID": 8000692846886,
    "Handle": "fisher-and-paykel-fridge-replacement-water-filter"
  },
  {
    "ID": 8000693010726,
    "Handle": "in-line-water-filters-trade-20-units-minimum"
  },
  {
    "ID": 8000693043494,
    "Handle": "cuno-part-no-cfs9812x"
  },
  {
    "ID": 8000693109030,
    "Handle": "water_filters_everpure_4c"
  },
  {
    "ID": 8000693174566,
    "Handle": "water_filters_everpure_4h"
  },
  {
    "ID": 8000693338406,
    "Handle": "reverse_osmosis_replacement_cartridges"
  },
  {
    "ID": 8000693502246,
    "Handle": "nsa-economy-replacement-filter-with-10mm-tube-adapters"
  },
  {
    "ID": 8000693829926,
    "Handle": "nsa_water_filters"
  },
  {
    "ID": 8000694321446,
    "Handle": "ultra-violet-system-sc2-5-9-5l-min-flow-and-prefilter"
  },
  {
    "ID": 8000694550822,
    "Handle": "uv-replacement-lamp-s287rl"
  },
  {
    "ID": 8000694714662,
    "Handle": "ceramic-cartridge-1-micron"
  },
  {
    "ID": 8000695009574,
    "Handle": "undersink-water-filter-with-ceramic-1-micron-cartridge"
  },
  {
    "ID": 8000695304486,
    "Handle": "connection-adapter-for-1-4-inch-to-1-4-inch-pipe-tubing"
  },
  {
    "ID": 8000695632166,
    "Handle": "twin-water-filter-cartridge-replacement"
  },
  {
    "ID": 8000695861542,
    "Handle": "water_filters_everpure_ac"
  },
  {
    "ID": 8000696090918,
    "Handle": "ultra-violet-system-sc4-15l-min-flow-only"
  },
  {
    "ID": 8000696320294,
    "Handle": "uv-replacement-lamp-s330-rl"
  },
  {
    "ID": 8000696615206,
    "Handle": "reverse-osmosis-membrane-replacement-act-fc-50-p"
  },
  {
    "ID": 8000696877350,
    "Handle": "anti-scaling-10-inch-cartridge"
  },
  {
    "ID": 8000697073958,
    "Handle": "undersink-water-filter-with-anti-scale-cartridge"
  },
  {
    "ID": 8000697303334,
    "Handle": "anti-scale-cartridge"
  },
  {
    "ID": 8000698188070,
    "Handle": "ultra-violet-system-s5q-pa-22l-min-flow-and-prefilter"
  },
  {
    "ID": 8000698450214,
    "Handle": "uv-replacement-lamp-s463rl"
  },
  {
    "ID": 8000698712358,
    "Handle": "anti-scale-taste-and-odour-ten-inch-cartridge-2408"
  },
  {
    "ID": 8000699040038,
    "Handle": "replacement-cuno-filters-ocs-cs-51"
  },
  {
    "ID": 8000699334950,
    "Handle": "ultra-violet-system-sc4-15l-min-flow-plus-prefilter"
  },
  {
    "ID": 8000699564326,
    "Handle": "ultra-violet-system-s8q-pa-37-9l-min-flow-and-prefilter"
  },
  {
    "ID": 8000699760934,
    "Handle": "uv_replacment_lamp_s810_rl"
  },
  {
    "ID": 8000700023078,
    "Handle": "ultra-violet-system-s12q-pa-57l-min-flow-and-prefilter"
  },
  {
    "ID": 8000700252454,
    "Handle": "uv-replacment-lamp-s36-rl"
  },
  {
    "ID": 8000700481830,
    "Handle": "water_filters_everpurebw100"
  },
  {
    "ID": 8000700809510,
    "Handle": "water_filters_everpure_bw400"
  },
  {
    "ID": 8000701202726,
    "Handle": "dw100-replacement-water-filters-incl-vat"
  },
  {
    "ID": 8000701464870,
    "Handle": "dw400-replacement-water-filters-incl-vat"
  },
  {
    "ID": 8000701825318,
    "Handle": "10-inch-polypropylene-pre-filter-20-micron"
  },
  {
    "ID": 8000702087462,
    "Handle": "20-inch-large-diameter-polypropylene-pre-filter-20-micron"
  },
  {
    "ID": 8000702480678,
    "Handle": "uv-pre-filter-for-s5q-pa-22l-x-2-replacement-pre-filter-code-fc-lead-20-30"
  },
  {
    "ID": 8000702742822,
    "Handle": "10-inch-large-diameter-polypropylene-pre-filters-20-micron"
  },
  {
    "ID": 8000703201574,
    "Handle": "10-inch-polypropylene-type-pre-filter-20-micron"
  },
  {
    "ID": 8000703529254,
    "Handle": "connection-adapter-for-15mm-to-1-4-inch-pipe-tube"
  },
  {
    "ID": 8000704348454,
    "Handle": "connection-adapter-for-12mm-to-1-4-inch-pipe-tube"
  },
  {
    "ID": 8000704971046,
    "Handle": "no-salt-water-softener-40l-larger-houses-and-post-filter"
  },
  {
    "ID": 8000705233190,
    "Handle": "no-salt-water-softener-20l-and-post-filter"
  },
  {
    "ID": 8000705495334,
    "Handle": "anti_scale_drinking_water"
  },
  {
    "ID": 8000708968742,
    "Handle": "bespoke-ace-for-kebabs-filter-media-replacement"
  },
  {
    "ID": 8000709132582,
    "Handle": "bespoke-ace-for-kebabs-filter"
  },
  {
    "ID": 8000709329190,
    "Handle": "water_softeners_buy_no_salt_40"
  },
  {
    "ID": 8000709624102,
    "Handle": "new-housing-unit-without-cartridge"
  },
  {
    "ID": 8000711885094,
    "Handle": "1-x-anti-scale-total-plus-1-x-master-purifier-cartridge"
  },
  {
    "ID": 8000712114470,
    "Handle": "anti-scale-undersink-water-filter-system"
  },
  {
    "ID": 8000717685030,
    "Handle": "reverse-osmosis-cartridge-renewal-with-remineraliser"
  },
  {
    "ID": 8000718078246,
    "Handle": "twin-anti-scale-taste-water-filter-cartridges-replacement"
  },
  {
    "ID": 8000718405926,
    "Handle": "water_filters_replace_stillo"
  },
  {
    "ID": 8000719290662,
    "Handle": "beko_fridge_external"
  },
  {
    "ID": 8000720372006,
    "Handle": "stillo_water_filter_cartridge_renewal"
  },
  {
    "ID": 8000721158438,
    "Handle": "franke-type-water-filters-replacement-cartridges"
  },
  {
    "ID": 8000722207014,
    "Handle": "replacement-water-filter-cartridge-special-offer-148"
  },
  {
    "ID": 8000722501926,
    "Handle": "replacement-water-filter-cartridge-special-offer-149"
  },
  {
    "ID": 8000722796838,
    "Handle": "replacement-water-filter-cartridge-special-offer-150"
  },
  {
    "ID": 8000723124518,
    "Handle": "water-filter-housing-o-ring"
  },
  {
    "ID": 8000723517734,
    "Handle": "franke_corinthian_filterflow"
  },
  {
    "ID": 8000723878182,
    "Handle": "franke_corinthian_filterflow_silk"
  },
  {
    "ID": 8000724336934,
    "Handle": "caravan-and-boat-filter-cartridge-with-12mm-pipework-adapters"
  },
  {
    "ID": 8000725090598,
    "Handle": "caravan-and-boat-filter-cartridge-discount-for-returning-customers"
  },
  {
    "ID": 8000725549350,
    "Handle": "franke-olympus-filterflow-chrome"
  },
  {
    "ID": 8000725844262,
    "Handle": "franke-olympus-filterflow-silk"
  },
  {
    "ID": 8000726270246,
    "Handle": "franke-kubus-filterflow-silk"
  },
  {
    "ID": 8000726663462,
    "Handle": "franke-kubus-filterflow-chrome"
  },
  {
    "ID": 8000727154982,
    "Handle": "franke-doric-filterflow-chrome-version"
  },
  {
    "ID": 8000727482662,
    "Handle": "franke-doric-filterflow-silk-steel-version"
  },
  {
    "ID": 8000727875878,
    "Handle": "anti_scale_solution1"
  },
  {
    "ID": 8000728826150,
    "Handle": "anti_scale_solution2"
  },
  {
    "ID": 8000729776422,
    "Handle": "anti_scale_six_or12"
  },
  {
    "ID": 8000730104102,
    "Handle": "connection-adapter-for-5-16-inch-to-1-4-inch-pipe-tubing"
  },
  {
    "ID": 8000730661158,
    "Handle": "undersink-water-filter-with-six-months-super-anti-scale"
  },
  {
    "ID": 8000730956070,
    "Handle": "special-mr-park"
  },
  {
    "ID": 8000731185446,
    "Handle": "ultra-violet-system-sc2-5-9-5l-min-flow-only"
  },
  {
    "ID": 8000731545894,
    "Handle": "water_filters_replace_rangemaster"
  },
  {
    "ID": 8000732365094,
    "Handle": "water_filters_replace_bristan_empura"
  },
  {
    "ID": 8000733118758,
    "Handle": "three-way-1-4-quarter-inch-tube-connector"
  },
  {
    "ID": 8000734134566,
    "Handle": "your-quick-connect-in-line-shut-off-valve"
  },
  {
    "ID": 8000734593318,
    "Handle": "ultra-violet-system-sp950-ho-196-l-min-flow-and-prefilter"
  },
  {
    "ID": 8000734953766,
    "Handle": "uv-replacment-lamp-s950rl"
  },
  {
    "ID": 8000735346982,
    "Handle": "brita_in_line_replace"
  },
  {
    "ID": 8000736657702,
    "Handle": "brita_p1000_replacements"
  },
  {
    "ID": 8000737870118,
    "Handle": "brita_a1000_replacements"
  },
  {
    "ID": 8000738558246,
    "Handle": "3-for-2-replacement-water-filter-cartridge-special-offer"
  },
  {
    "ID": 8000738885926,
    "Handle": "ultra-violet-system-s1q-p-12vdc-7-5-min-flow-and-prefilter"
  },
  {
    "ID": 8000739213606,
    "Handle": "industrial-water-filter-60-l-minute"
  },
  {
    "ID": 8000739574054,
    "Handle": "1-2-inch-housing-unit"
  },
  {
    "ID": 8000739836198,
    "Handle": "fibre-glass-cerc"
  },
  {
    "ID": 8000740065574,
    "Handle": "ultra-violet-system-sp410-ho-90-8-l-min-flow-and-prefilter"
  },
  {
    "ID": 8000740262182,
    "Handle": "standard-20-inch-housing"
  },
  {
    "ID": 8000740491558,
    "Handle": "20-inch-polypropylene-pre-filter-5-micron"
  },
  {
    "ID": 8000740786470,
    "Handle": "3-for-2-in-line-water-filter-replacement"
  },
  {
    "ID": 8000741048614,
    "Handle": "ultra-violet-system-sc1-4l-min-flow-and-prefilter"
  },
  {
    "ID": 8000741376294,
    "Handle": "ultra-violet-system-sp600-ho-132-5-l-min-flow-and-prefilter"
  },
  {
    "ID": 8000741605670,
    "Handle": "uv-replacment-lamp-sp600-ho"
  },
  {
    "ID": 8000741835046,
    "Handle": "uv-replacment-lamp-s212rl"
  },
  {
    "ID": 8000742097190,
    "Handle": "new-housing-unit-ql3b-without-cartridge"
  },
  {
    "ID": 8000742326566,
    "Handle": "new-everpure-housing-unit-ql3b-without-cartridge"
  },
  {
    "ID": 8000742555942,
    "Handle": "housing-unit-incl-cartridge-to-replace-my-brita"
  },
  {
    "ID": 8000742752550,
    "Handle": "new-everpure-housing-unit-bw-s-ev427123-bw-filter-head-with-1-4-inch-pf-connections-without-cartridge"
  },
  {
    "ID": 8000742883622,
    "Handle": "r-pfset-ld10-1-pre-filter-housing-for-37l-per-min-uv"
  },
  {
    "ID": 8000743014694,
    "Handle": "water-softeners-salt-206"
  },
  {
    "ID": 8000743276838,
    "Handle": "water-softeners-salt-207"
  },
  {
    "ID": 8000743506214,
    "Handle": "water_softeners_twentymetered"
  },
  {
    "ID": 8000743833894,
    "Handle": "water_softeners_twentytimed"
  },
  {
    "ID": 8000744096038,
    "Handle": "magnetic_descaler_15mm"
  },
  {
    "ID": 8000744489254,
    "Handle": "anti-scale-electrolytic-gold-22mm-compression-401065"
  },
  {
    "ID": 8000745013542,
    "Handle": "dentists_reverse_osmosis"
  },
  {
    "ID": 8000746750246,
    "Handle": "1-custom-installation-undersink-drinking-water-filter"
  },
  {
    "ID": 8000746881318,
    "Handle": "1-custom-installation-scb-keep-your-existing-tap-undersink-water-filter"
  },
  {
    "ID": 8000747012390,
    "Handle": "salt-less-water-softener-60-ltr-p-min-for-larger-houses"
  },
  {
    "ID": 8000747176230,
    "Handle": "uv-replacment-lamp-s320rl"
  },
  {
    "ID": 8000747307302,
    "Handle": "ultra-violet-system-sp320-ho-68-1-min-flow-and-prefilter"
  },
  {
    "ID": 8000747503910,
    "Handle": "ultra-violet-system-s2q-pa-11l-min-flow-only"
  },
  {
    "ID": 8000747700518,
    "Handle": "brita-8430531-inline-replacement"
  },
  {
    "ID": 8000748126502,
    "Handle": "67003662_fridge_filters"
  },
  {
    "ID": 8000748454182,
    "Handle": "puriclean_fridge_filters"
  },
  {
    "ID": 8000748618022,
    "Handle": "ukf7003-fridge-filters-222"
  },
  {
    "ID": 8000748912934,
    "Handle": "ukf7003-fridge-filters"
  },
  {
    "ID": 8000749273382,
    "Handle": "whirlpool_4396510_fridge_filter"
  },
  {
    "ID": 8000751206694,
    "Handle": "in-line-anti-scale-filter"
  },
  {
    "ID": 8000751567142,
    "Handle": "uv-replacement-lamp-l034"
  },
  {
    "ID": 8000751698214,
    "Handle": "beko_4830310100_filter"
  },
  {
    "ID": 8000751862054,
    "Handle": "1-x-your-discount-in-line-water-filter-renewal"
  },
  {
    "ID": 8000752025894,
    "Handle": "discount-in-line-water-filter-renewal"
  },
  {
    "ID": 8000752320806,
    "Handle": "sbs005_fridge_filters"
  },
  {
    "ID": 8000753631526,
    "Handle": "hotpoint-internal-fridge-filter"
  },
  {
    "ID": 8000753795366,
    "Handle": "lg-lt500p-fridge-water-filter"
  },
  {
    "ID": 8000754254118,
    "Handle": "lg_fridge_replacements_lt600p"
  },
  {
    "ID": 8000754417958,
    "Handle": "1-custom-installation-anti-scale-electrolytic-gold-15mm-compression"
  },
  {
    "ID": 8000754581798,
    "Handle": "1-custom-installation-anti-scale-electrolytic-gold-22mm-compression"
  },
  {
    "ID": 8000754712870,
    "Handle": "everpure-4h-water-filter-cartridge-ex-vat"
  },
  {
    "ID": 8000754876710,
    "Handle": "uv-replacement-lamp-nlr1880"
  },
  {
    "ID": 8000755106086,
    "Handle": "uv-pre-filter-for-s950rl-ho-replacement-pre-filter-nw50"
  },
  {
    "ID": 8000755269926,
    "Handle": "ultra-violet-system-s1q-pa-7-5l-min-flow-and-pre-filter"
  },
  {
    "ID": 8000755532070,
    "Handle": "ultra-violet-system-s5q-pa-22l-min-flow-and-prefilter-iron-manganese-filters"
  },
  {
    "ID": 8000755728678,
    "Handle": "uv-replacement-lamp-lo42-30w-to-replace-liff-30n"
  },
  {
    "ID": 8000755892518,
    "Handle": "everpure-scale-stick"
  },
  {
    "ID": 8000756023590,
    "Handle": "water_filters_replacement_male_inline"
  },
  {
    "ID": 8000756416806,
    "Handle": "bottom-of-page-sales-stuff-asd"
  },
  {
    "ID": 8000756515110,
    "Handle": "technical-dummy-eds_testal"
  },
  {
    "ID": 8000756678950,
    "Handle": "car-wash-water-filter"
  },
  {
    "ID": 8000757006630,
    "Handle": "health_practioners"
  },
  {
    "ID": 8000757203238,
    "Handle": "high_flow_kit_for_salt_based_softeners"
  },
  {
    "ID": 8000757301542,
    "Handle": "10_big_blue_gac_cartridge"
  },
  {
    "ID": 8000757399846,
    "Handle": "ultra_violet_pre_filter_housing_unit_with_sediment_filter_only_for_s5q-pa_22l"
  },
  {
    "ID": 8000757432614,
    "Handle": "caple_puriti_1_replacement_cartridge"
  },
  {
    "ID": 8000757661990,
    "Handle": "10-inch-polypropylene-pre-filters-20-micron"
  },
  {
    "ID": 8000757727526,
    "Handle": "uv-replacment-lamp-sp410rl-ho-260"
  },
  {
    "ID": 8000757858598,
    "Handle": "overseas-delivery-eu"
  },
  {
    "ID": 8000757891366,
    "Handle": "f418_big_blue_10_4_5_dia_sediment_filter"
  },
  {
    "ID": 8000758022438,
    "Handle": "insinkerator_f701-r_replacement_filters"
  },
  {
    "ID": 8000758219046,
    "Handle": "designer-water-filter-tap"
  },
  {
    "ID": 8000758776102,
    "Handle": "insinkerator_f701-r_replacement_filter_single"
  },
  {
    "ID": 8000758972710,
    "Handle": "philips_tuv_75w_g75_t8_uv_lamp_l058"
  },
  {
    "ID": 8000759071014,
    "Handle": "3m_filters_compatible_with_ap2_401_s_anti_scale"
  },
  {
    "ID": 8000759234854,
    "Handle": "the-life-saving-straw-xxx"
  },
  {
    "ID": 8000759660838,
    "Handle": "portable_water_filter_-_pump_type"
  },
  {
    "ID": 8000759791910,
    "Handle": "dosaplus_media"
  },
  {
    "ID": 8000759857446,
    "Handle": "uv_pre-filter_for_sp600-ho_132_5_l_min_replacement_pre-filter_code_r-nw_50_62_75-sleeve_25_pack_of_5"
  },
  {
    "ID": 8000762347814,
    "Handle": "bosch_siemens_ultra_clarity_internal_fridge_filter"
  },
  {
    "ID": 8000762577190,
    "Handle": "blanco_filtra_compatible_replacement_water_filter_cartridge"
  },
  {
    "ID": 8000762904870,
    "Handle": "omnipure-e5520psb3"
  },
  {
    "ID": 8000762970406,
    "Handle": "salamander_aquamaster_mini_replacement"
  },
  {
    "ID": 8000763134246,
    "Handle": "bayhall_filtamate_replacements"
  },
  {
    "ID": 8000763363622,
    "Handle": "20_inch_cartridge_carbon_block"
  },
  {
    "ID": 8000763527462,
    "Handle": "big-blue-cartridge-20-micron"
  },
  {
    "ID": 8000763625766,
    "Handle": "hanovia-uvd35-ultra-violet-replace-lamps"
  },
  {
    "ID": 8000763691302,
    "Handle": "fountain_filters_pearl_h_replacement"
  },
  {
    "ID": 8000763920678,
    "Handle": "test_3456"
  },
  {
    "ID": 8000764018982,
    "Handle": "instanta_aq5_aq6_taste_and_odour_compatible_filter"
  },
  {
    "ID": 8000764215590,
    "Handle": "instanta_aq1_aq2_aq3_aq4_compatible_anti_scale_filter"
  },
  {
    "ID": 8000764313894,
    "Handle": "replacement_pentek_crb2_10_filter_cartridge"
  },
  {
    "ID": 8000764543270,
    "Handle": "replacement_pentek_chlorplus_10"
  },
  {
    "ID": 8000764772646,
    "Handle": "replace-culligan_tfcart"
  },
  {
    "ID": 8000764870950,
    "Handle": "spectrum_pleated_filter_cartridge"
  },
  {
    "ID": 8000765100326,
    "Handle": "ukwf-p1000-replacement-cartridge"
  },
  {
    "ID": 8000765296934,
    "Handle": "uv_iron_manganese_reduction_pre-filter_for_s5q-pa_22l_replacement_pre-filter_code_fcld-iron_red_20"
  },
  {
    "ID": 8000765362470,
    "Handle": "a1000_retro-fit_cartridge_replacement"
  },
  {
    "ID": 8000765428006,
    "Handle": "lamona_hk1032_compatible_water_filter"
  },
  {
    "ID": 8000765591846,
    "Handle": "inline_water_filter_sodastream_filterstream"
  },
  {
    "ID": 8000765722918,
    "Handle": "reverse_osmosis_system_sanitiser_1_litre_bottle"
  },
  {
    "ID": 8000765788454,
    "Handle": "compatible_aquadial_cart_1_cart_3_replacement_cartridge"
  },
  {
    "ID": 8000765952294,
    "Handle": "compatible_aquadial_ad2600_replacement_cartridge"
  },
  {
    "ID": 8000766050598,
    "Handle": "liff_compatible_pro_2cpf_filter"
  },
  {
    "ID": 8000766148902,
    "Handle": "everpure_mh_cartridges_filters"
  },
  {
    "ID": 8000766247206,
    "Handle": "fountain_filters_pearl_t_replacement_cartridges"
  },
  {
    "ID": 8000766411046,
    "Handle": "own_tap_water_filter"
  },
  {
    "ID": 8000766607654,
    "Handle": "compatible_aquadial_ad100_ad000100_replacement_cartridge"
  },
  {
    "ID": 8000766771494,
    "Handle": "in_line_water_filter_compatible_with_opella_female_connection"
  },
  {
    "ID": 8000766935334,
    "Handle": "in_line_water_filter_compatible_with_water_gem_male_connections"
  },
  {
    "ID": 8000767033638,
    "Handle": "the-life-saving-straw-316"
  },
  {
    "ID": 8000767099174,
    "Handle": "in_line_water_filter_to_replace_omnipure_k2583"
  },
  {
    "ID": 8000767230246,
    "Handle": "leak_stop_leak_prevention_protector"
  },
  {
    "ID": 8000767492390,
    "Handle": "in_line_water_filter_to_replace_omnipure_k2520"
  },
  {
    "ID": 8000767623462,
    "Handle": "samsung_fridge_internal_filters2"
  },
  {
    "ID": 8000767852838,
    "Handle": "whirlpool_4396510_fridge_filter2"
  },
  {
    "ID": 8000768704806,
    "Handle": "puriclean_fridge_filters2"
  },
  {
    "ID": 8000769261862,
    "Handle": "john_guest_tap_adaptor_1_4_inch_to_3_4_inch_bsp_ci320816fs"
  },
  {
    "ID": 8000769655078,
    "Handle": "new_housing_unit_with_anti_scale_cartridge"
  },
  {
    "ID": 8000771424550,
    "Handle": "new_housing_unit_with_anti_scale_cartridge2"
  },
  {
    "ID": 8000773194022,
    "Handle": "keep_your_existing_tap_-_undersink_water_filter"
  },
  {
    "ID": 8000773587238,
    "Handle": "nss_high_flow_gac_cartridge_post_filter"
  },
  {
    "ID": 8000773685542,
    "Handle": "hanovia_ws214_ultra_violet_lamps"
  },
  {
    "ID": 8000773849382,
    "Handle": "anti-scale-cartridge-lasts-six-months"
  },
  {
    "ID": 8000774078758,
    "Handle": "doulton_frf03_water_filters_replacement_cartridges"
  },
  {
    "ID": 8000774406438,
    "Handle": "sleeve_s12q-pa_uv_lamp"
  },
  {
    "ID": 8000774570278,
    "Handle": "w_of_h_ukwf_20"
  },
  {
    "ID": 8000775520550,
    "Handle": "w_of_h_ukwf_40"
  },
  {
    "ID": 8000776208678,
    "Handle": "whole_of_house_with_scale_reduction"
  },
  {
    "ID": 8000777126182,
    "Handle": 89103
  },
  {
    "ID": 8000777322790,
    "Handle": "no-salt-softener-single-unit-20l-min"
  },
  {
    "ID": 8000778404134,
    "Handle": "no-salt-softener-larger-40l"
  },
  {
    "ID": 8000779059494,
    "Handle": "ro-9-litre-storage-vessel"
  },
  {
    "ID": 8000779321638,
    "Handle": "whole-of-house-with-scale-reduction-larger-size-40l-min-20-inch"
  },
  {
    "ID": 8000780435750,
    "Handle": "renewal_kit_for_no-salt_water_softener_40l_larger_houses"
  },
  {
    "ID": 8000780599590,
    "Handle": "inline_water_filter_with_push_fit_connectors"
  },
  {
    "ID": 8000781091110,
    "Handle": "ultra-violet-system-l22-22l-min-flow-and-prefilter"
  },
  {
    "ID": 8000781222182,
    "Handle": "uv_replacement_lamp_rl-22"
  },
  {
    "ID": 8000781418790,
    "Handle": "s-d_slimline_shu1000_5_micron_3_4_connections"
  },
  {
    "ID": 8000781615398,
    "Handle": "10-inch-polypropylene-pre-filter-5-micron"
  },
  {
    "ID": 8000781812006,
    "Handle": "20-inch-filter-housing-unit-large-diameter"
  },
  {
    "ID": 8000781943078,
    "Handle": "uv-pre-filter-code-pf-ld-10-30-377"
  },
  {
    "ID": 8000782172454,
    "Handle": "delivery_uk"
  },
  {
    "ID": 8000782303526,
    "Handle": "connection_adapters_pair_14_nptf_male_x_14_pushfit"
  },
  {
    "ID": 8000782631206,
    "Handle": "15mm_female_to_1_4_inch_female_pm011516e_with_ci320816fs"
  },
  {
    "ID": 8000783024422,
    "Handle": "15mm_pipe_shut_off_valve"
  },
  {
    "ID": 8000783221030,
    "Handle": "smeg_fa55xbil1_fridge_filter"
  },
  {
    "ID": 8000783548710,
    "Handle": "shut_off_valve_for_3_8_inch_9_6mm_tube"
  },
  {
    "ID": 8000783810854,
    "Handle": "ukwf-reverse-osmosis-cartridge-renewal-with-remineraliser"
  },
  {
    "ID": 8000784040230,
    "Handle": "electrolux_frigidaire_wf2cb_puresource_2_fridge_water_filter"
  },
  {
    "ID": 8000785154342,
    "Handle": "ultra_violet_system_l12_11_4l_min_flow_and_prefilter"
  },
  {
    "ID": 8000785318182,
    "Handle": "uv-replacment-lamp-rl-12-362"
  },
  {
    "ID": 8000785416486,
    "Handle": "nitrates_pre_filter_unit_for_uv_l12"
  },
  {
    "ID": 8000785514790,
    "Handle": "nitrates_pre_filter_cartridge_for_uv_l12"
  },
  {
    "ID": 8000785678630,
    "Handle": "20-inch-polypropylene-pre-filter-20-micron"
  },
  {
    "ID": 8000785875238,
    "Handle": "uv_replacement_lamp_l034_liff"
  },
  {
    "ID": 8000786071846,
    "Handle": "uv-replacement-lamp-lo43-to-replace-liff-p55n-367"
  },
  {
    "ID": 8000786235686,
    "Handle": "whole_of_house_filter_renewal_single_unit_-_20l_min"
  },
  {
    "ID": 8000787120422,
    "Handle": "whole_of_house_filter_renewal_double_unit_-_40l_min"
  },
  {
    "ID": 8000787317030,
    "Handle": "scale_centurion_filter_renewal_single_unit_20l_min"
  },
  {
    "ID": 8000788037926,
    "Handle": "scale_centurion_filter_renewal_double_unit_-_40l_min"
  },
  {
    "ID": 8000788201766,
    "Handle": "whole_house_with_scale_reduction_filter_renewal_single_unit_-_20l_min"
  },
  {
    "ID": 8000789348646,
    "Handle": "whole_house_with_scale_reduction_filter_renewal_single_unit_-_40l_min"
  },
  {
    "ID": 8000789545254,
    "Handle": "test-test"
  },
  {
    "ID": 8000789643558,
    "Handle": "remineraliser_filter_for_reverse_osmosis_system"
  },
  {
    "ID": 8000789741862,
    "Handle": "special_delivery"
  },
  {
    "ID": 8000789872934,
    "Handle": "10-inch-large-diameter-polypropylene-pre-filter-5-micron"
  },
  {
    "ID": 8000790102310,
    "Handle": "shut-off-valve-for-5-16-inch-8mm-tube"
  },
  {
    "ID": 8000790298918,
    "Handle": "your_scale_centurion_undersink_cartridge"
  },
  {
    "ID": 8000790659366,
    "Handle": "uv_replacment_lamp_rl-41"
  },
  {
    "ID": 8000790757670,
    "Handle": "ultra_violet_system_41l_min_flow_and_prefilter"
  },
  {
    "ID": 8000790987046,
    "Handle": "3g_samsung_fridge_type_internal_filter"
  },
  {
    "ID": 8000791642406,
    "Handle": "ultra_violet_system_12l_min_flow_and_prefilter"
  },
  {
    "ID": 8000791773478,
    "Handle": "uv-replacment-lamp-rl-12-386"
  },
  {
    "ID": 8000791904550,
    "Handle": "uv_replacement_lamp_l042"
  },
  {
    "ID": 8000792035622,
    "Handle": "10_inch_ld_50_micron_pleated_filters"
  },
  {
    "ID": 8000792166694,
    "Handle": "sleeve_for_the_s8q-pa_uv_lamp"
  },
  {
    "ID": 8000792264998,
    "Handle": "ultra-violet-system-57l-min-flow-and-prefilter"
  },
  {
    "ID": 8000792494374,
    "Handle": "uv_replacment_lamp_rl-57"
  },
  {
    "ID": 8000792625446,
    "Handle": "your_undersink_scale_centurion_system"
  },
  {
    "ID": 8000792854822,
    "Handle": "your_scale_centurion_undersink_housing_unit"
  },
  {
    "ID": 8000793051430,
    "Handle": "samsung_fridge_type_internal_filter"
  },
  {
    "ID": 8000793608486,
    "Handle": "undersink_water_filter_cartridges_so7"
  },
  {
    "ID": 8000793805094,
    "Handle": "iron_manganese_hm_reduction_pre_filter_unit"
  },
  {
    "ID": 8000793968934,
    "Handle": "ultra-violet-system-79l-min-flow-and-prefilter"
  },
  {
    "ID": 8000794263846,
    "Handle": "uv_replacment_lamp_rl-79"
  },
  {
    "ID": 8000794427686,
    "Handle": "large-dia-water-filter-housing-o-ring"
  },
  {
    "ID": 8000794624294,
    "Handle": "ultra-violet-system-ukwf-uv22l-min-flow-with-prefilter"
  },
  {
    "ID": 8000794820902,
    "Handle": "uv_lamp_ukwf-pb25w"
  },
  {
    "ID": 8000795050278,
    "Handle": "quartz_sleeve_for_uv_lamp_rl-22"
  },
  {
    "ID": 8000795181350,
    "Handle": "special_offer_2_x_water_filter_cartridges"
  },
  {
    "ID": 8000795509030,
    "Handle": "special-offer-2-x-american-fridge-water-filters"
  },
  {
    "ID": 8000795738406,
    "Handle": "special_offer_1_x_american_fridge_water_filter"
  },
  {
    "ID": 8000796131622,
    "Handle": "special_offer_2_x_in_line_water_filters"
  },
  {
    "ID": 8000796360998,
    "Handle": "in_line_water_filters"
  },
  {
    "ID": 8000796655910,
    "Handle": "special_offer_2_x_inline_water_filters_male_connections"
  },
  {
    "ID": 8000796786982,
    "Handle": "inline_water_filter_male_connections"
  },
  {
    "ID": 8000796885286,
    "Handle": "special_offer_1_x_water_filter_cartridge"
  },
  {
    "ID": 8000797016358,
    "Handle": "ultra_violet_system_325l_min_flow"
  },
  {
    "ID": 8000797114662,
    "Handle": "uv_lamp_325l_min"
  },
  {
    "ID": 8000797180198,
    "Handle": "overseas_delivery_row"
  },
  {
    "ID": 8000797245734,
    "Handle": "buy_one_for_15_95"
  },
  {
    "ID": 8000797376806,
    "Handle": "buy_2_for_26_90_you_save_5"
  },
  {
    "ID": 8000797573414,
    "Handle": "buy_3_for_39_you_save_8_85"
  },
  {
    "ID": 8000797638950,
    "Handle": "buy_one_for_13_95"
  },
  {
    "ID": 8000797737254,
    "Handle": "buy_2_for_23_90_you_save_4"
  },
  {
    "ID": 8000797835558,
    "Handle": "buy_3_for_34_85_you_save_7"
  },
  {
    "ID": 8000797933862,
    "Handle": "uv_pre-filters_pf-ld-20_5_pack_of_5"
  },
  {
    "ID": 8000798032166,
    "Handle": "uv_pre-filters_pf-ld-20_10_pack_of_5"
  },
  {
    "ID": 8000798130470,
    "Handle": "special_offer_1_x_anti_scale_cartridge"
  },
  {
    "ID": 8000798261542,
    "Handle": "special_offer_2_x_anti_scale_cartridges"
  },
  {
    "ID": 8000798425382,
    "Handle": "ultra_violet_system_uv22l-12v_min_flow_and_prefilter"
  },
  {
    "ID": 8000798589222,
    "Handle": "3sg_samsung_fridge_type_internal_filter"
  },
  {
    "ID": 8000798753062,
    "Handle": "ise_7000_replacement_filter"
  },
  {
    "ID": 8000798916902,
    "Handle": "ise_7000_replacement_insinkerator_filter_pack_of_2"
  },
  {
    "ID": 8000799047974,
    "Handle": "mem-ro_reverse_osmosis_membrane_replacement"
  },
  {
    "ID": 8000799113510,
    "Handle": "ff_cnc_15a_external_fridge_filter"
  },
  {
    "ID": 8000799244582,
    "Handle": "so-test-page"
  },
  {
    "ID": 8000799342886,
    "Handle": "ff_ab29_samsung_fridge_type_internal_filter"
  },
  {
    "ID": 8000799506726,
    "Handle": "ff_ukc_73_internal_fridge_filter"
  },
  {
    "ID": 8000799572262,
    "Handle": "epw_b1_everpure_water_filter"
  },
  {
    "ID": 8000799703334,
    "Handle": "epw_b4_everpure_water_filter"
  },
  {
    "ID": 8000799768870,
    "Handle": "evp_c4_everpure_water_filter"
  },
  {
    "ID": 8000799834406,
    "Handle": "evp_h4_everpure_water_filter"
  },
  {
    "ID": 8000799899942,
    "Handle": "evp_ca_everpure_water_filter"
  },
  {
    "ID": 8000799998246,
    "Handle": "ukwf_ff02_internal_fridge_filter"
  },
  {
    "ID": 8000800063782,
    "Handle": "ukwf_ff04_internal_fridge_filter"
  },
  {
    "ID": 8000800260390,
    "Handle": "ukwf_ff03_fridge_filter"
  },
  {
    "ID": 8000800424230,
    "Handle": "ff_ef2_fridge_water_filter"
  },
  {
    "ID": 8000800653606,
    "Handle": "ff_ucff_internal_fridge_filter"
  },
  {
    "ID": 8000800719142,
    "Handle": "special_filter_for_caravans_and_boats12"
  },
  {
    "ID": 8000800882982,
    "Handle": "uv_replacement_lamp_f-s463rl_12v"
  },
  {
    "ID": 8000800948518,
    "Handle": 89104
  },
  {
    "ID": 8000801177894,
    "Handle": "connection_adapter_set_for_1_4_to_3_8_inch_male_spiggot"
  },
  {
    "ID": 8000801407270,
    "Handle": "connection_adapters_pair_3_8_nptf_male_x_1_4_pushfit"
  },
  {
    "ID": 8000801538342,
    "Handle": "connection_adapters_pair_1_4_nptf_male_x_1_4_pushfit_short_stemmed"
  },
  {
    "ID": 8000801734950,
    "Handle": "connection_adapters_pair_1_4_nptf_male_x_5_16_pushfit"
  },
  {
    "ID": 8000801931558,
    "Handle": "replacement_water_filter_cartridge_to_fit_10_inch_blue_or_white_housing"
  },
  {
    "ID": 8000802357542,
    "Handle": "15mm_x_3_4_bsp_connection_adapters_pair_3_4_bsp_x_15mm_pushfit"
  },
  {
    "ID": 8000802521382,
    "Handle": "special_offer_1_x_keep_my_existing_tap_undersink_water_filter"
  },
  {
    "ID": 8000802816294,
    "Handle": "special_offer_2_x_keep_my_existing_tap_undersink_water_filters"
  },
  {
    "ID": 8000803340582,
    "Handle": "special_offer_1_x_shower_water_filter_cartridge"
  },
  {
    "ID": 8000803537190,
    "Handle": "special_offer_2_x_shower_water_filter_cartridges"
  },
  {
    "ID": 8000803701030,
    "Handle": "stem_adaptor_bsp_set_for_10mm_to_1_4_inch"
  },
  {
    "ID": 8000803832102,
    "Handle": "46lt_scale_centurion_system"
  },
  {
    "ID": 8000803897638,
    "Handle": "60lt_scale_centurion_system"
  },
  {
    "ID": 8000804028710,
    "Handle": "10-inch-polypropylene-pre-filter-50-micron"
  },
  {
    "ID": 8000804127014,
    "Handle": "in_line_water_filter_compatible_omnipure_cl-series_-_female_connection"
  },
  {
    "ID": 8000804421926,
    "Handle": "pre_filter_unit_with_100_micron_sleeve"
  },
  {
    "ID": 8000804487462,
    "Handle": "25_micron_sleeve_-_pack_of_5_for_ukwf50-nw"
  },
  {
    "ID": 8000804552998,
    "Handle": "replacement_in_line_water_filter_compatible_with_omnipure_k2533_type_water_filter"
  },
  {
    "ID": 8000804815142,
    "Handle": "slimline-gac-cartridge"
  },
  {
    "ID": 8000804978982,
    "Handle": "replacement_option_for_your_pentek_cbr2-10_filter_cartridge"
  },
  {
    "ID": 8000805273894,
    "Handle": "scale_centurion_cartridge_renewal_20_inch_-_40l_min_re-order_code_sc-bb-ca-20"
  },
  {
    "ID": 8000805503270,
    "Handle": "ukwf_ff01_internal_fridge_filter"
  },
  {
    "ID": 8000805830950,
    "Handle": "water_filter_cartridge_to_replace_pentek_epm_10_type_filter_cartridge"
  },
  {
    "ID": 8000806158630,
    "Handle": "in_line_water_filter_compatible_liff_n_fil_female_connections"
  },
  {
    "ID": 8000806322470,
    "Handle": "in_line_water_filter_compatible_liff_n_sk_13_female_connections"
  },
  {
    "ID": 8000806486310,
    "Handle": "whirlpool_fridge_style_external_water_filter"
  },
  {
    "ID": 8000806682918,
    "Handle": "water_filter_cartridge_to_replace_watts_maxpb_975_type_filter_cartridge"
  },
  {
    "ID": 8000806977830,
    "Handle": "kemflo_aicro_aicro-nsf_fridge_style_external_water_filter"
  },
  {
    "ID": 8000807305510,
    "Handle": "american_style_fridge_filters_buy_2_for_24_50_you_save_5"
  },
  {
    "ID": 8000807403814,
    "Handle": "buy_one_for_14_75"
  },
  {
    "ID": 8000807567654,
    "Handle": "buy_one_for_15_95_b"
  },
  {
    "ID": 8000807829798,
    "Handle": "buy_3_for_34_25_you_save_10"
  },
  {
    "ID": 8000807960870,
    "Handle": "buy_one_for_37"
  },
  {
    "ID": 8000807993638,
    "Handle": "buy_2_for_64_you_save_10"
  },
  {
    "ID": 8000808124710,
    "Handle": "buy_3_for_92_you_save_19"
  },
  {
    "ID": 8000808223014,
    "Handle": 89106
  },
  {
    "ID": 8000808354086,
    "Handle": "special_offer2_whole_house_water_filter"
  },
  {
    "ID": 8000808550694,
    "Handle": "ultra_violet_system_ukwf-uv9_5l_min_flow_and_prefilter"
  },
  {
    "ID": 8000808747302,
    "Handle": "buy_3_for_38_85_you_save_9"
  },
  {
    "ID": 8000808878374,
    "Handle": "buy_one_for_29_97"
  },
  {
    "ID": 8000809107750,
    "Handle": "buy_2_for_49_94_you_save_10"
  },
  {
    "ID": 8000809238822,
    "Handle": "buy_3_for_74_91_you_save_15"
  },
  {
    "ID": 8000809435430,
    "Handle": "buy_one_for_39_97"
  },
  {
    "ID": 8000809664806,
    "Handle": "buy_2_for_64_94_you_save_15"
  },
  {
    "ID": 8000809763110,
    "Handle": "buy_3_for_99_91_you_save_20"
  },
  {
    "ID": 8000809894182,
    "Handle": "buy_one_for_19_95"
  },
  {
    "ID": 8000810418470,
    "Handle": "buy_2_for_32_90_you_save_7"
  },
  {
    "ID": 8000810942758,
    "Handle": "buy_3_for_49_85_you_save_10"
  },
  {
    "ID": 8000811532582,
    "Handle": "buy_one_internal_fridge_filter_for_19_95"
  },
  {
    "ID": 8000811991334,
    "Handle": "buy_2_filters_for_32_90_you_save_7"
  },
  {
    "ID": 8000812581158,
    "Handle": "buy_3_filters_for_49_85_you_save_10"
  },
  {
    "ID": 8000812941606,
    "Handle": "buy_one_fln2000_for_15_95"
  },
  {
    "ID": 8000813072678,
    "Handle": "buy_2_fln2000_for_26_90_you_save_5"
  },
  {
    "ID": 8000813203750,
    "Handle": "buy_3_fln2000_for_38_85_you_save_9"
  },
  {
    "ID": 8000813367590,
    "Handle": "renewal_kit_for_no-salt_water_softener_60l_larger_houses"
  },
  {
    "ID": 8000813465894,
    "Handle": "liebherr_sbs7052-4_type_external_fridge_filter"
  },
  {
    "ID": 8000813760806,
    "Handle": "maytag_fridge_type_internal_filter"
  },
  {
    "ID": 8000813957414,
    "Handle": "undersink_water_filter_with_connectors"
  },
  {
    "ID": 8000814317862,
    "Handle": "undersink_water_filter_cartridge"
  },
  {
    "ID": 8000814580006,
    "Handle": "half_price_cartridge_with_free_replacement_ports"
  },
  {
    "ID": 8000814743846,
    "Handle": "half_price_anti_scale_filter_cartridge_with_free_replacement_ports"
  },
  {
    "ID": 8000814973222,
    "Handle": "anti_scale_super_taste_cartridge_lasts_6_months"
  },
  {
    "ID": 8000815169830,
    "Handle": "anti_scale_super_taste_up_to_one_year"
  },
  {
    "ID": 8000815399206,
    "Handle": "brita-p1000-tap-water-filter-cartridge"
  },
  {
    "ID": 8000815563046,
    "Handle": "renewal_kit_for_no-salt_water_softener_20"
  },
  {
    "ID": 8000815694118,
    "Handle": "dental_reverse_osmosis_cartridges"
  },
  {
    "ID": 8000815792422,
    "Handle": "in-line_filter_compatible_with_whale_aquasource_clear_wf1230"
  },
  {
    "ID": 8000816087334,
    "Handle": "in-line_filter_compatible_with_whale_aquasource_clear_wf1530"
  },
  {
    "ID": 8000816316710,
    "Handle": "paini_type_water_filter_replacement_cartridge"
  },
  {
    "ID": 8000816447782,
    "Handle": "uv_replacment_lamp_rl_850"
  },
  {
    "ID": 8000816578854,
    "Handle": "20_inch_granular_activated_carbon_cartridge"
  },
  {
    "ID": 8000816677158,
    "Handle": "20_inch_pp_sediment_water_filter_cartridge_1micron"
  },
  {
    "ID": 8000816775462,
    "Handle": "whole_house_filter_renewal_20_inch_-_40l_min"
  },
  {
    "ID": 8000816939302,
    "Handle": "whole_of_house_filter_renewal"
  },
  {
    "ID": 8000817463590,
    "Handle": "scale_centurion_filter_renewal"
  },
  {
    "ID": 8000817955110,
    "Handle": "whole_house_filter_renewal"
  },
  {
    "ID": 8000818086182,
    "Handle": 89107
  },
  {
    "ID": 8000818315558,
    "Handle": "special_offer_2_x_keep_existing_tap_undersink_water_filters"
  },
  {
    "ID": 8000818577702,
    "Handle": "special_offer_1_x_keep_existing_tap_undersink_water_filter"
  },
  {
    "ID": 8000818807078,
    "Handle": "special_offer_1_x_samsung_fridge_type_internal_filter"
  },
  {
    "ID": 8000819069222,
    "Handle": "special_offer_2_x_samsung_fridge_type_internal_filters"
  },
  {
    "ID": 8000819298598,
    "Handle": "special_offer_1a3_x_anti_scale_cartridge"
  },
  {
    "ID": 8000819462438,
    "Handle": "special_offer_2a3_x_anti_scale_cartridges"
  },
  {
    "ID": 8000819691814,
    "Handle": "20-inch-large-diameter-polypropylene-pre-filter-50-micron"
  },
  {
    "ID": 8000819855654,
    "Handle": "special_offer_two_reverse_osmosis_cartridge_kits_with_remineralisers"
  },
  {
    "ID": 8000819921190,
    "Handle": "special_offer_reverse_osmosis_cartridge_kit_with_remineraliser"
  },
  {
    "ID": 8000820085030,
    "Handle": "special_offer_1_x_reverse_osmosis_cartridge_kit"
  },
  {
    "ID": 8000820248870,
    "Handle": "special_offer_2_x_reverse_osmosis_cartridge_kits"
  },
  {
    "ID": 8000820379942,
    "Handle": "special_offer_1_x_reverse_osmosis_filter_kit_with_remineraliser"
  },
  {
    "ID": 8000820511014,
    "Handle": "special_offer_2_x_reverse_osmosis_filter_kits_with_remineralisers"
  },
  {
    "ID": 8000820609318,
    "Handle": "special_offer_a1_2_x_american_fridge_water_filters"
  },
  {
    "ID": 8000820904230,
    "Handle": "special_offer_a1_1_x_american_fridge_water_filter"
  },
  {
    "ID": 8000821133606,
    "Handle": "special_offer_a1_2_x_water_filter_cartridges"
  },
  {
    "ID": 8000821297446,
    "Handle": "special_offer_a1_1_x_water_filter_cartridge"
  },
  {
    "ID": 8000821657894,
    "Handle": "special_offer_a1_2_x_inline_water_filters_male_connections"
  },
  {
    "ID": 8000821985574,
    "Handle": "inline_water_filter_a1_male_connections"
  },
  {
    "ID": 8000822313254,
    "Handle": "special_offer_a1_1_x_keep_my_existing_tap_undersink_water_filter"
  },
  {
    "ID": 8000822575398,
    "Handle": "special_offer_a1_2_x_keep_my_existing_tap_undersink_water_filters"
  },
  {
    "ID": 8000822870310,
    "Handle": "a1_in_line_water_filter"
  },
  {
    "ID": 8000823132454,
    "Handle": "special_offer_a1_2_x_in_line_water_filters"
  },
  {
    "ID": 8000823329062,
    "Handle": "special_offer_a1_1_x_shower_water_filter_cartridge"
  },
  {
    "ID": 8000823623974,
    "Handle": "special_offer_a1_2_x_shower_water_filter_cartridges"
  },
  {
    "ID": 8000823918886,
    "Handle": "special_offer_a1_1_x_samsung_fridge_type_internal_filter"
  },
  {
    "ID": 8000824213798,
    "Handle": "special_offer_a1_2_x_samsung_fridge_type_internal_filters"
  },
  {
    "ID": 8000824475942,
    "Handle": "special_offer_a1_1_x_reverse_osmosis_cartridge_kit"
  },
  {
    "ID": 8000824607014,
    "Handle": "special_offer_a1_2_x_reverse_osmosis_cartridge_kits"
  },
  {
    "ID": 8000824770854,
    "Handle": "scale_centurion_media_refill_40l"
  },
  {
    "ID": 8000824836390,
    "Handle": "special-offer-aw-2-x-american-fridge-water-filters"
  },
  {
    "ID": 8000825032998,
    "Handle": "special-offer-aw-1-x-american-fridge-water-filter"
  },
  {
    "ID": 8000825295142,
    "Handle": "special-offer-aw-2-water-filter-cartridges"
  },
  {
    "ID": 8000825524518,
    "Handle": "special-offer-aw-1-water-filter-cartridge"
  },
  {
    "ID": 8000825819430,
    "Handle": "keep-my-existing-tap-aw-undersink-water-filter"
  },
  {
    "ID": 8000826016038,
    "Handle": "keep-my-existing-tap-aw2-undersink-water-filters"
  },
  {
    "ID": 8000826278182,
    "Handle": "scale_centurion_media_refill_20l"
  },
  {
    "ID": 8000826343718,
    "Handle": "special-offer-aw-2-anti-scale-cartridges"
  },
  {
    "ID": 8000826605862,
    "Handle": "special-offer-aw-1-anti-scale-cartridge"
  },
  {
    "ID": 8000826769702,
    "Handle": "special-offer-aw-2-x-antiscale3-cartridges"
  },
  {
    "ID": 8000826999078,
    "Handle": "special-offer-aw-1-x-anti-scale3-cartridge"
  },
  {
    "ID": 8000827228454,
    "Handle": "10-inch-polypropylene-sediment-pre-filter-1-micron"
  },
  {
    "ID": 8000827293990,
    "Handle": "3m_scalegard_pro_165_p165bn-e_replacement_cartridge"
  },
  {
    "ID": 8000827359526,
    "Handle": "special-offer-aw-2-x-shower-water-filter-cartridges"
  },
  {
    "ID": 8000827556134,
    "Handle": "special-offer-aw-1-x-shower-water-filter-cartridge"
  },
  {
    "ID": 8000827785510,
    "Handle": "aw-special-offer-2-keep-your-own-tap-water-filters"
  },
  {
    "ID": 8000827982118,
    "Handle": "aw-special-offer-1-x-keep-your-own-tap-water-filter"
  },
  {
    "ID": 8000828178726,
    "Handle": "scale-centurion-filter-renewal-double-unit-40l-min-re-order-code-sc-bb-ca-20"
  },
  {
    "ID": 8000828604710,
    "Handle": "special_offer_aw_reverse_osmosis_membrane_replacement"
  },
  {
    "ID": 8000828768550,
    "Handle": "special_offer_aw_2_x_reverse_osmosis_membrane_replacements"
  },
  {
    "ID": 8000828866854,
    "Handle": "special-offer-aw-1-x-samsung-fridge-type-internal-filter"
  },
  {
    "ID": 8000829161766,
    "Handle": "special-offer-aw-2-x-samsung-fridge-type-internal-filters"
  },
  {
    "ID": 8000829522214,
    "Handle": "special-offer-aw-1-x-reverse-osmosis-cartridge-kit"
  },
  {
    "ID": 8000829686054,
    "Handle": "special-offer-aw-2-x-reverse-osmosis-cartridge-kits"
  },
  {
    "ID": 8000829849894,
    "Handle": "special_offer_aw_1_x_reverse_osmosis_cartridge_kit_with_remineraliser"
  },
  {
    "ID": 8000829980966,
    "Handle": "special_offer_aw_2_x_reverse_osmosis_cartridge_kits_with_remineralisers"
  },
  {
    "ID": 8000830144806,
    "Handle": "special-offer-aw-in-line-water-filter"
  },
  {
    "ID": 8000830406950,
    "Handle": "special-offer-aw-2-x-in-line-water-filters"
  },
  {
    "ID": 8000830505254,
    "Handle": "aw_reverse_osmosis_cartridge_kit_with_remineraliser"
  },
  {
    "ID": 8000830669094,
    "Handle": "special_offer_aw2_2_x_reverse_osmosis_cartridge_kits_with_remineralisers"
  },
  {
    "ID": 8000830767398,
    "Handle": "new-housing-unit-replace-franke-with-6-month-anti-scale-cartridge"
  },
  {
    "ID": 8000831160614,
    "Handle": "delivery_eu_2"
  },
  {
    "ID": 8000831258918,
    "Handle": "ultra_violet_system_12v_uvs41_41l_min_flow_and_prefilter"
  },
  {
    "ID": 8000831422758,
    "Handle": "uv_replacement_lamp_l037"
  },
  {
    "ID": 8000831619366,
    "Handle": "reverse-osmosis-aw-cartridge-pack-with-demineraliser"
  },
  {
    "ID": 8000831783206,
    "Handle": "two-reverse-aw2-osmosis-cartridge-packs-with-demineraliser"
  },
  {
    "ID": 8000831979814,
    "Handle": "12v-dc-controller"
  },
  {
    "ID": 8000832045350,
    "Handle": "ultra-violet-system-151l-min-flow-no-pre-filter"
  },
  {
    "ID": 8000832405798,
    "Handle": 89108
  },
  {
    "ID": 8000832831782,
    "Handle": "uv-replacement-lamp-s-d-rl-h151"
  },
  {
    "ID": 8000832962854,
    "Handle": "in_line_aw-water_filter_male_connections"
  },
  {
    "ID": 8000833224998,
    "Handle": "in_line_aw2_water_filters_male_connections"
  },
  {
    "ID": 8000833323302,
    "Handle": "remineraliser-filter-cartridge"
  },
  {
    "ID": 8000833519910,
    "Handle": "water-filter-cartridge-gac-ld"
  },
  {
    "ID": 8000833716518,
    "Handle": "fluoride_reduction_filter_cartridge"
  },
  {
    "ID": 8000833814822,
    "Handle": "pre_filter_unit_including_fluoride_reduction_filter_cartridge"
  },
  {
    "ID": 8000833913126,
    "Handle": "ultra-violet-system-ukwf-uv15l-min-flow-and-prefilter"
  },
  {
    "ID": 8000834208038,
    "Handle": "ukwf-gernlr1845_uv_lamp"
  },
  {
    "ID": 8000834339110,
    "Handle": "10_inch_wound_polyproylene_filter_100_micron"
  },
  {
    "ID": 8000834404646,
    "Handle": 89111
  },
  {
    "ID": 8000834568486,
    "Handle": "reverse-osmosis-cartridge-kit-with-demineraliser"
  },
  {
    "ID": 8000834732326,
    "Handle": "whole-of-house-with-scale-reduction-larger-size-40l-min-old-1877"
  },
  {
    "ID": 8000835322150,
    "Handle": "whole_house_water_filter_plus_scale_centurion_cartridge_renewal"
  },
  {
    "ID": 8000835649830,
    "Handle": "twin_pre_filter_housing_unit_including_gac_carbon_filter_plus_polypropylene_sediment_filter"
  },
  {
    "ID": 8000835846438,
    "Handle": "10-inch-large-diameter-polypropylene-pre-filter-20-micron"
  },
  {
    "ID": 8000836043046,
    "Handle": "gac_ten_inch_large_diameter_filter_cartridge"
  },
  {
    "ID": 8000836108582,
    "Handle": "20_inch_large_diameter_iron_removal_pre_filter_housing_unit"
  },
  {
    "ID": 8000836206886,
    "Handle": "bosch-siemens-neff-coffee"
  },
  {
    "ID": 8000836370726,
    "Handle": "ten_inch_big_blue_housing_unit_-_large_diameter"
  },
  {
    "ID": 8000836534566,
    "Handle": 89113
  },
  {
    "ID": 8000836731174,
    "Handle": "scale_centurion_114_l_per_minute_system"
  },
  {
    "ID": 8000836796710,
    "Handle": "replacement_scale_centurion_media_for_sc114"
  },
  {
    "ID": 8000836960550,
    "Handle": "ultra-violet-system-ukwf-uv45l-min-flow-and-prefilter"
  },
  {
    "ID": 8000837320998,
    "Handle": "uv-lamp-ukwf-pb5w"
  },
  {
    "ID": 8000837517606,
    "Handle": "10_inch_large_diameter_pre_filter_unit_including_20_micron_polypropylene_filter"
  },
  {
    "ID": 8000837648678,
    "Handle": "undersink-home-water-filters-test"
  },
  {
    "ID": 8000837812518,
    "Handle": "20-inch-carbon-block-filter-5-micron-large-diameter-4-5-iinch"
  },
  {
    "ID": 8000837943590,
    "Handle": "undersink-home-water-filters-test-2691"
  },
  {
    "ID": 8000838140198,
    "Handle": "undersink-home-water-filters-2986"
  },
  {
    "ID": 8000838402342,
    "Handle": "demineraliser-filter-for-reverse-osmosis-system"
  },
  {
    "ID": 8000838533414,
    "Handle": "franke-type-water-filters-replacement-cartridges-2659"
  },
  {
    "ID": 8000838762790,
    "Handle": "doulton-water-filter-replacement-cartridges"
  },
  {
    "ID": 8000839287078,
    "Handle": "20-inch-large-diameter-polypropylene-pre-filter-5-micron"
  },
  {
    "ID": 8000839516454,
    "Handle": "replacement-bulb-for-havonia-130034-0361-01"
  },
  {
    "ID": 8000839647526,
    "Handle": "water_filters_replace_doulton"
  },
  {
    "ID": 8000840073510,
    "Handle": "20_inch_large_diameter_pre_filter_housing_unit_including_5_micron_polypropylene_sediment_filter"
  },
  {
    "ID": 8000840171814,
    "Handle": 89115
  },
  {
    "ID": 8000840466726,
    "Handle": "doulton-water-filters-replacement-cartridges-push-fit"
  },
  {
    "ID": 8000840728870,
    "Handle": "franke-doulton-ultracarb"
  },
  {
    "ID": 8000841023782,
    "Handle": "franke-doulton-supercarb"
  },
  {
    "ID": 8000841318694,
    "Handle": "doulton-ultracarb-short"
  },
  {
    "ID": 8000841580838,
    "Handle": "doulton-supercarb-short"
  },
  {
    "ID": 8000841744678,
    "Handle": "fixed_elbow_nptf_-_1_4_x_1_4_push_fit"
  },
  {
    "ID": 8000841908518,
    "Handle": "5_16_stem_adapter_to_1_4_push_fit"
  },
  {
    "ID": 8000841974054,
    "Handle": "total-anti-scale-media-replacement-20l-per-min"
  },
  {
    "ID": 8000842006822,
    "Handle": "total-anti-scale-media-replacement-40l-per-min"
  },
  {
    "ID": 8000842105126,
    "Handle": "john_guest_male_adaptor_15mm_pf_x_3_8_bsp"
  },
  {
    "ID": 8000842268966,
    "Handle": "connection_adapter_for_10mm_to_8mm_pipe_tubing"
  },
  {
    "ID": 8000842432806,
    "Handle": "john_guest_male_connector_12mm_x_3_8_bspp"
  },
  {
    "ID": 8000842563878,
    "Handle": "reducing_straigh_connector_12mm_-_8mm"
  },
  {
    "ID": 8000842694950,
    "Handle": "total-anti-scale-media-replacement-46l-per-min"
  },
  {
    "ID": 8000842760486,
    "Handle": "total-anti-scale-media-replacement-60l-per-min"
  },
  {
    "ID": 8000842826022,
    "Handle": "ultra_violet_system_uv12l-12v_min_flow_and_prefilter"
  },
  {
    "ID": 8000842891558,
    "Handle": "the-flow-king-ro80"
  },
  {
    "ID": 8000842957094,
    "Handle": "the-flow-king-ro40"
  },
  {
    "ID": 8000843022630,
    "Handle": "extra-water-filter-1-4-inch-tubing-per-metre"
  },
  {
    "ID": 8000843120934,
    "Handle": "spare-replacement-6-month-cartridge"
  },
  {
    "ID": 8000843317542,
    "Handle": "spare-replacement-6-month-shower-water-filter-cartridge"
  },
  {
    "ID": 8000843415846,
    "Handle": "spare-replacement-6-month-scale-cartridge"
  },
  {
    "ID": 8000843481382,
    "Handle": "spare-replacement-12-month-scale-cartridge"
  },
  {
    "ID": 8000843645222,
    "Handle": "fridge-water-filter-compatible-with-ge-smartwater-gwf-mwf"
  },
  {
    "ID": 8000844071206,
    "Handle": "spare-set-of-replacement-filters-for-reverse-osmosis-system"
  },
  {
    "ID": 8000844169510,
    "Handle": "spare-set-of-replacement-filters-for-dental-reverse-osmosis-system"
  },
  {
    "ID": 8000844267814,
    "Handle": "spare-replacement-keep-your-own-tap-filter"
  },
  {
    "ID": 8000844398886,
    "Handle": "extra-meter-of-tubing"
  },
  {
    "ID": 8000844529958,
    "Handle": "housing_unit_with_15mm_female_ports"
  },
  {
    "ID": 8000844595494,
    "Handle": "larger-ro-tank-18l-capacity"
  },
  {
    "ID": 8000844759334,
    "Handle": "ukwf_high_flow_filter_housing_ukbh2000"
  },
  {
    "ID": 8000844988710,
    "Handle": "ro_tank_valve_for_1_4_inch_tube"
  },
  {
    "ID": 8000845152550,
    "Handle": "50_micron_pleated_pre_filter"
  },
  {
    "ID": 8000845185318,
    "Handle": "ultra-violet-system-uv110l-min-flow-no-prefilter"
  },
  {
    "ID": 8000845283622,
    "Handle": "ultra-violet-lamp-110l-min-flow"
  },
  {
    "ID": 8000845349158,
    "Handle": "triflow-tfe500-type-filters-replacement-cartridges"
  },
  {
    "ID": 8000845447462,
    "Handle": "20_inch_large_diameter_iron_removal_filter"
  },
  {
    "ID": 8000845512998,
    "Handle": "uv_lamp_a10_replacement_lamp-zfa10uv01"
  },
  {
    "ID": 8000845578534,
    "Handle": "dental_surgery_reverse_osmosis_replacement_filter_pack"
  },
  {
    "ID": 8000845807910,
    "Handle": "ultrafiltration-0_01micron-filters"
  },
  {
    "ID": 8000846037286,
    "Handle": "ukwf-ip-ff01-internal-fridge-filter-renewal"
  },
  {
    "ID": 8000846233894,
    "Handle": "connection-adapter-half-inch-quarter-inch"
  },
  {
    "ID": 8000846430502,
    "Handle": "jg-asv3-15mm-to-quarter-inch"
  },
  {
    "ID": 8000846496038,
    "Handle": "half-inch-male-to-1-2-inch-female-adapter"
  },
  {
    "ID": 8000855638310,
    "Handle": "pro_microbiological_water_quality_test"
  },
  {
    "ID": 8000855736614,
    "Handle": "test_02_physical_chemical_water_quality_test"
  },
  {
    "ID": 8000855834918,
    "Handle": "test_03_physical_chemical_water_quality_test"
  },
  {
    "ID": 8000856064294,
    "Handle": "installment-plan-50"
  },
  {
    "ID": 8000856162598,
    "Handle": "10_inch_large_diameter_polypropylene_pre_filter_10_micron"
  },
  {
    "ID": 8000856293670,
    "Handle": "ultra_violet_system_ukwf-uv22l12v_min_flow_and_prefilter"
  },
  {
    "ID": 8000856457510,
    "Handle": "pre-filter-high-flow"
  },
  {
    "ID": 8000856621350,
    "Handle": "50-micron-sock-pre-filters"
  },
  {
    "ID": 8000856785190,
    "Handle": "jura-claris-coffee-jug-filters"
  },
  {
    "ID": 8000856981798,
    "Handle": "brita-intenza-coffee-filters"
  },
  {
    "ID": 8000857145638,
    "Handle": "krups-f088-coffee-jug-filters"
  },
  {
    "ID": 8000857243942,
    "Handle": "80lt-scale-centurion-system"
  },
  {
    "ID": 8000857309478,
    "Handle": "20_inch_large_diameter_polypropylene_pre_filter_1_micron"
  },
  {
    "ID": 8000857473318,
    "Handle": "adapter-connectors-pack"
  },
  {
    "ID": 8000857669926,
    "Handle": "ultra-violet-system-ukwf-uv9-5l-min-flow-12v-and-prefilter"
  },
  {
    "ID": 8000857899302,
    "Handle": "credit-installment-1-ro-ukwf"
  },
  {
    "ID": 8000857997606,
    "Handle": "50_installment_payment_for_your_water_filter_credit_plan"
  },
  {
    "ID": 8000858161446,
    "Handle": "reverse-osmosis-cartridge-replacement-kit-up"
  },
  {
    "ID": 8000858259750,
    "Handle": "reverse_osmosis_cartridge_renewal_with_remineraliser"
  },
  {
    "ID": 8000858390822,
    "Handle": "whole-of-house-with-scale-reduction-larger-homes-paid-by-monthly-installments-197-then-8-100"
  },
  {
    "ID": 8000858489126,
    "Handle": "100_installment_payment_for_your_water_filter_credit_plan"
  },
  {
    "ID": 8000858554662,
    "Handle": "scale-centurion-filter-renewal-single-unit-20l-min-re-order-code-sc-bb-ca-10"
  },
  {
    "ID": 8000858718502,
    "Handle": "whole_house_filter_renewal_single_unit_-_20l_min_re-order_code_fil-wh-ca-10"
  },
  {
    "ID": 8000858784038,
    "Handle": "ultra-violet-lamp-130034-0361-01"
  },
  {
    "ID": 8000858849574,
    "Handle": "scale-centurion-media-refill-80lpm"
  },
  {
    "ID": 8000858980646,
    "Handle": "dental_demin_filters_extra_pack_-_pair"
  },
  {
    "ID": 8000859111718,
    "Handle": "10-inch-large-diameter-pleated-pre-filter-30-micron"
  },
  {
    "ID": 8000859177254,
    "Handle": 89119
  },
  {
    "ID": 8000859275558,
    "Handle": "pre-filter-high-flow-400-litres"
  },
  {
    "ID": 8000859406630,
    "Handle": "high_flow_particulate_sediment_filter_500_litres_per_minute_max"
  },
  {
    "ID": 8000859537702,
    "Handle": "high_flow_particulate_sediment_filter_replacement_1_micron_pack_of_5"
  },
  {
    "ID": 8000859603238,
    "Handle": "high_flow_particulate_sediment_filter_replacement_5_micron_pack_of_5"
  },
  {
    "ID": 8000859734310,
    "Handle": "10_micron_high_flow_particulate_sediment_screen_sock_filter_replacement_pack_of_5"
  },
  {
    "ID": 8000859832614,
    "Handle": "20-micron_high_flow_particle_sediment_filters_-_replacement_pack_of_5"
  },
  {
    "ID": 8000859930918,
    "Handle": "50_micron_high_flow_particulate_sediment_filters_-_replacement_pack_of_5"
  },
  {
    "ID": 8000860029222,
    "Handle": "100_micron_high_flow_particulate_sediment_filters_-_replacement_pack_of_5"
  },
  {
    "ID": 8000860127526,
    "Handle": "150_micron_high_flow_particulate_sediment_filters_-_replacement_pack_of_5"
  },
  {
    "ID": 8000860258598,
    "Handle": "300_micron_high_flow_rate_sediment_particle_filters_-_replacement_pack_of_5"
  },
  {
    "ID": 8000860324134,
    "Handle": "water_filter_anti-scale_media_annual_usage_deal_-_four_sachet_pack"
  },
  {
    "ID": 8000860487974,
    "Handle": "water_filter_anti-scale_media_annual_usage_deal_-_four_sachet_pack_-_heavy_duty"
  },
  {
    "ID": 8000860651814,
    "Handle": "water_filter_anti-scale_media_annual_usage_deal_-_two_sachet_pack_-_medium_to_heavy_scale_areas"
  },
  {
    "ID": 8000860848422,
    "Handle": "water_filter_anti-scale_media_annual_usage_deal_-_twin_sachet_pack_-_heavy_duty"
  },
  {
    "ID": 8000861045030,
    "Handle": "reverse_osmosis_pump"
  },
  {
    "ID": 8000861176102,
    "Handle": "20_inch_long_slimline_dia_150_micron_wound_polypropylene_filter"
  },
  {
    "ID": 8000861307174,
    "Handle": "water_filter_anti-scale_media_annual_usage_deal_-_one_refill_sachet_-_medium_to_heavy_scale_areas"
  },
  {
    "ID": 8000861471014,
    "Handle": "water_filter_anti-scale_media_annual_usage_deal_-_one_refill_sachet_-_heavy_scale_areas"
  },
  {
    "ID": 8000861667622,
    "Handle": "ultra-violet-system-uv15l12v-prefilter"
  },
  {
    "ID": 8000861798694,
    "Handle": "water_filters_reverse_osmosis2"
  },
  {
    "ID": 8000862552358,
    "Handle": "samsung_fridge_internal_filters_demo"
  },
  {
    "ID": 8000862978342,
    "Handle": "carbon-water-filter-media-one-refill-sachet"
  },
  {
    "ID": 8000863109414,
    "Handle": "fisher-paykel-847200-type-fridge-filter"
  },
  {
    "ID": 8000863437094,
    "Handle": "anti-scale-media-one-refill-sachet-medium-to-heavy-scale-areas"
  },
  {
    "ID": 8000863502630,
    "Handle": "carbon_block_cartridge_0_5_micron_10_inch_large_diameter"
  },
  {
    "ID": 8000863600934,
    "Handle": "tank_housing_shut_off_valve_for_1_4_inch_-_6_4mm_tubing"
  },
  {
    "ID": 8000863666470,
    "Handle": "proboil-replacement-filter-type"
  },
  {
    "ID": 8000863928614,
    "Handle": "reverse_osmosis_system_with_pump"
  },
  {
    "ID": 8000864256294,
    "Handle": "reverse_osmosis_pump_cartridges_6_month_renewal_kit"
  },
  {
    "ID": 8000864321830,
    "Handle": "total-anti-scaling-water-filter-unit"
  },
  {
    "ID": 8000865206566,
    "Handle": "replacement-leak-stop-expansion-pads-twin-pack"
  },
  {
    "ID": 8000865370406,
    "Handle": "installment-plan-40"
  },
  {
    "ID": 8000865468710,
    "Handle": "water_filters_reverse_osmosis-ab"
  },
  {
    "ID": 8000866976038,
    "Handle": "connection-adapter-pair-for-22mm-to-22mm-pipe"
  },
  {
    "ID": 8000867533094,
    "Handle": "carbon-water-filter-media-refill-sachet-two"
  },
  {
    "ID": 8000867860774,
    "Handle": "quooker-scale-control-plus-alternative"
  },
  {
    "ID": 8000868090150,
    "Handle": "boiling-water-tap-replacement"
  },
  {
    "ID": 8000868253990,
    "Handle": "insinkerator_hot_tap_compatible_replacement"
  },
  {
    "ID": 8000868450598,
    "Handle": "bristan_rapsnk4_sf_c_compatible_replacement"
  },
  {
    "ID": 8000868745510,
    "Handle": "haier-hrwf-type-fridge-water-filter"
  },
  {
    "ID": 8000868876582,
    "Handle": "ceramic_valve_tp-des"
  },
  {
    "ID": 8000869007654,
    "Handle": "whole-house-filter-media-sachet-renewal-double-unit-standard-size"
  },
  {
    "ID": 8000869138726,
    "Handle": "whole-house-filter-plus-scale-centurion-media-sachets-renewal-double-unit-standard-size"
  },
  {
    "ID": 8000869269798,
    "Handle": "whole-house-filter-media-sachet-renewal-double-unit-high-flow"
  },
  {
    "ID": 8000869400870,
    "Handle": "whole-house-filter-plus-scale-centurion-media-sachets-renewal-double-unit-high-flow"
  },
  {
    "ID": 8000869466406,
    "Handle": "whole_house_filter_-_media_sachet_renewal_-_single_unit_standard_size"
  },
  {
    "ID": 8000869564710,
    "Handle": "scale_centurion_-_media_sachet_renewal_-_single_unit_-_standard_size"
  },
  {
    "ID": 8000869630246,
    "Handle": "scale_centurion_-_media_sachet_renewal_-_single_unit_-_high_flow"
  },
  {
    "ID": 8000869695782,
    "Handle": "whole_house_filter_-_media_sachet_renewal_-_single_unit_high_flow"
  },
  {
    "ID": 8000869794086,
    "Handle": "reverse_osmosis_4_way_splitter"
  },
  {
    "ID": 8000869957926,
    "Handle": "reverse_osmosis_restrirctor_valve"
  }
];

 function getQueryStringParameters() {
     var parameters = {}, hash;
     var q = document.URL.split('?')[1];
     if(q != undefined) {
         q = q.split('&');
         for(var i = 0; i < q.length; i++) {
             hash = q[i].split('=');
             parameters[hash[0]] = hash[1];
         }
     }
     return parameters;
  }

  function isEmpty(obj) {
     for(var key in obj) {
     if(obj.hasOwnProperty(key))
     return false;
     }
     return true;
  }

  $(document).ready(function() {
   var parameters = getQueryStringParameters();
   if(isEmpty(parameters) == false) {
   $.each(parameters, function(key, value) {
     if (key == "product_id") {
       var myHandle = KlavHandle.find(item => item.ID == value);
       window.location.href = 'https://uk-water-filters.myshopify.com/products/' + myHandle.Handle;
       //console.log(myHandle.Handle);
     }
   });
   }
  });


